/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/


import React  from 'react';
import Card from './puff/card.jsx';

import MagazineCopy from './magazineCopy.jsx';
import MessageBubble from "./modal/messagebubble.jsx";
import Login from "./modal/login.jsx";
import { connect } from 'react-redux';
import {setFocusedPuff} from '../actions/view';

var Scroll = require('react-scroll');
var scroller = Scroll.scroller;
var scrollSpy  = Scroll.scrollSpy;

class Feed extends React.Component {

  constructor(props) {
    super(props);
    this.state = {linear:true};
    this.feedScroll = null
  }

  scrollContainer(){
    return document.getElementById(this.props.id+"-scroll")
  }


  render() {

    var {feed, mobile, user, id} = this.props

    let loggedIn = user && user.email

    if(['404','410'].includes(window.status)){
        return <MessageBubble mobile={mobile} message={window.status}/>
    }

    if(!loggedIn){
      return null
    }

    var self = this
    let page = feed && feed.menu ? feed.menu.find(m=>m.selected && m.type==='feed') : null
    let noResultsFound = (feed && feed.lastRequest.query && feed.lastRequest.query.length>0 && feed.puffs.length===0 && !feed.isFetching)

    const linearSelected = feed.menu.filter(e=>{
      return e.type==='view' && (e.value==="linear" || e.value==='linearL') && e.selected;
    }).length>0;

    const linearLargeSelected = feed.menu.filter(e=>{
      return e.type==='view' && e.value==='linearL' && e.selected;
    }).length>0;



    const magazineLength = 30
    // const isLinear = (this.state.linear || linearSelected);
    const isLinear = false//(!magazineSelected && (mobile || linearSelected));
    var childElements=[]
    //TODO: check key convension
    // TODO: this should be a function called from underlying component(linear/masonry)
      // console.log(feed)
      let fullPuff = linearLargeSelected //|| (feed.puffs.length===1 && !self.isMobile())

          childElements = feed.puffs.map((article, index)=>{
                  let keyId = id+"-puffs-"+index;
                  return  <Card writeAccess={(feed.write || feed.id==='profile')}
                                featured={!mobile && index===0 && !(page && page.value==='orders')}
                                page={page && page.value ? page.value : null}
                                feedId={feed.id}
                                tabId={self.props.feed ? self.props.feed.id : null}
                                single={fullPuff}
                                isLinear={isLinear}
                                user={user}
                                lFormatter={self.props.lFormatter}
                                scrollId={id}
                                scrollKey={keyId}
                                key={keyId+"-"+article.id}
                                id={keyId+"-"+article.id}
                                article={article} />


          });



      if(feed.private){
        return loggedIn ? <MessageBubble feed={feed} message="private"/> : <Login title="This feed is private, sign in to continue" redirect={window.location.pathname} justLogin={true} style={{margin:'auto'}}/>
      }

      let sampleMessage = 'Currently showing previews.'
      let noneFound = 'No news stories were found, try to expand your query'


      let product =  feed.menu.find(e=>e.type==='product' && e.selected)
      product = product ? product.value : null

      let samples = (feed.puffs && feed.puffs[0] && feed.puffs[0].cluster)

      let feedMessage = null

      feedMessage = noResultsFound ? <MessageBubble mobile={mobile} sticky={true} type="alert" icon='exclamation-triangle' message={'notfound'} query={feed.lastRequest.query}/> : feedMessage


      if((page && page.value==='orders') && childElements.length===0){
        feedMessage = <MessageBubble query={feed.lastRequest.query} mobile={mobile} message="noorders"/>
      }

      if(product==='unlocked' && (feed && feed.puffs && feed.puffs.length===0)){
        feedMessage = <MessageBubble user={user} feed={feed} query={feed.lastRequest.query} mobile={mobile} message="noarticles"/>
      }

      if(!loggedIn && ((page && page.value==='search') || feed.id==='en')){
        feedMessage = <MessageBubble mobile={mobile} sticky={!mobile} type="alert" icon='exclamation-triangle' text="These articles are created by our Artificial Intelligence." button="TRY FOR FREE"/>
      }

      let topics=[]

        return (<MagazineCopy style={this.props.style ? this.props.style : undefined} newButton={null} myFeeds={feed.id==='profile' ? this.props.myFeeds : null} message={feed.isFetching ? null : feedMessage} updateScroll={this.props.updateScroll} scrollId={id+'-scroll'} key={id+"-msnry"} id={id+"-msnry"} feed={feed}>
                {childElements}
                </MagazineCopy>)




  }
}

const mapStateToProps = (state)=>{
  return {
    user:state.auth.user
  }
}

export default connect(mapStateToProps)(Feed)

// export default Feed

const s = {
  message:{
    fontWeight: 'bold',
    padding: '15px 20px',
    color:'#5d5d5d',
    backgroundColor: '#e9e9e9',
    borderRadius: 30,
    margin: 15,
    display: 'inline-block'
  },
  loginButton:{
    color:'white',
    border: 'solid 1px',
    padding: '5px 11px',
    borderRadius: 15,
    display: 'inline-block'
  }
}
